import { useEffect } from 'react';
import { useMonitorStore } from './lib/monitorStore';
import { monitorClient } from './lib/MonitorClient';
import { LoginPage } from './components/LoginPage';
import { Dashboard } from './components/Dashboard';

export default function App() {
  const { isAuthenticated } = useMonitorStore();

  useEffect(() => {
    if (isAuthenticated) {
      monitorClient.connect();
      return () => monitorClient.disconnect();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <Dashboard />;
}
